
const Footer = () => {
    return (
        <footer className="footer" id="footer">
            <div className="container">
                <div className="footer-brand">
                    <a href="#" className="logo">
                        <div className="logo-light">Advisors Reserve</div>
                    </a>

                    <p className="footer-text">
                        Purpose-built CRM for financial advisors--helping you manage relationships with
                        ease, fill forms at the click of a button, and maintain full control of your data.
                    </p>

                    <p className="footer-text">
                        Advisors Reserve &copy; {new Date().getFullYear()} <br /> All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default Footer